<template>
  <form class="vr360-flex-column vr360-app-main__proff" @submit.prevent="submitForm">
    <div class="vr360-app-main__proff__ava">
      <p class="vr360-avatar-stub vr360-app-main__proff__ava__img">
        <template v-if="editDataUser.avatar.blob || editDataUser.avatar.val">
          <template v-if="editDataUser.avatar.blob">
            <img :src="editDataUser.avatar.blob">
          </template>
          <template v-else>
            <img :src="editDataUser.avatar.val | storagePath">
          </template>
          <button
            type="button"
            class="vr360-app-main__proff__ava__img__remove-btn"
            @click="removeAvatar"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.412 12.625l11.25-11.25"
                stroke="currentColor"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
              ></path>
              <path
                d="M1.413 1.375l11.25 11.25"
                stroke="currentColor"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </button>
        </template>
        <template v-else>
          <label class="vr360-app-main__proff__ava__upload">
            <input type="file" accept=".jpg, .jpeg, .png" @change="uploadAvatar">
          </label>
        </template>
      </p>
    </div>
    <div class="vr360-input-text">
      <input class="vr360-text-reg" type="text" placeholder=" " v-model="editDataUser.name.val">
      <label>
        <span class="vr360-head-h4 vr360-text-gray-2">Name</span>
        <p class="vr360-text-caption">message</p>
      </label>
    </div>
    <div class="vr360-input-text">
      <input class="vr360-text-reg" type="text" placeholder=" " v-model="editDataUser.surname.val">
      <label>
        <span class="vr360-head-h4 vr360-text-gray-2">Surname</span>
        <p class="vr360-text-caption">message</p>
      </label>
    </div>
    <div class="vr360-input-text">
      <input class="vr360-text-reg" type="email" placeholder=" " v-model="editDataUser.email.val">
      <label>
        <span class="vr360-head-h4 vr360-text-gray-2">Email</span>
        <p class="vr360-text-caption">message</p>
      </label>
    </div>

    <div class="vr360-input-text">
      <input
        class="vr360-text-reg"
        type="password"
        placeholder=" "
        v-model="editDataUser.password.val"
      >
      <label>
        <span class="vr360-head-h4 vr360-text-gray-2">Password</span>
        <p class="vr360-text-caption">password</p>
      </label>
    </div>

    <!-- <div class="vr360-app-main__proff__facebook">
      <p class="vr360-head-h4">Connected to Facebook account</p>
      <a href="#" class="vr360-link vr360-app-main__proff__facebook__link">
        <span class="vr360-app-main__proff__facebook__link__icon">
          <i class="vr360-icon bg-facebook"></i>
        </span>
        <span class="vr360-text-reg">Kirk Hammet</span>
      </a>
    </div>-->
    <div class="vr360-app-main__bottom" v-if="!submit">
      <button type="submit" class="vr360-btn" :disabled="isDisabled">
        <span>Save changes</span>
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import resizerImg from "@/assets/js/resizeImg";

export default {
  name: "EditProfile",
  data() {
    return {
      editDataUser: {
        email: {
          val: "",
          error: ""
        },
        name: {
          val: "",
          error: ""
        },
        password: {
          val: "",
          error: ""
        },
        surname: {
          val: "",
          error: ""
        },
        avatar: {
          val: "",
          blob: "",
          error: "",
          change_avatar: false
        }
      },
      submit: false,
      passwords: {
        oldPassword: "",
        newPassword: "",
        confPassword: ""
      }
    };
  },
  created() {
    this.prepareUserToEdit(this.user);
  },
  methods: {
    ...mapActions({
      showNotification: "showNotification",
      updateUser: "user/updateUser"
    }),
    prepareUserToEdit(val) {
      if (!this.submit) {
        for (var key of Object.keys(val)) {
          if (this.editDataUser[key]) this.editDataUser[key].val = val[key];
        }
      }
    },
    uploadAvatar(event) {
      let target = event.target;
      let uploadedFile = target.files[0];

      if (uploadedFile.type.split("/")[0] === "image") {
        this.editDataUser.avatar.change_avatar = true;
        this.showThumbImg(uploadedFile);
      } else {
        target.value = "";

        this.showNotification({
          type: "error",
          message: "Can't upload file"
        });
      }
    },
    resizeImg(img) {
      const that = this;

      resizerImg(img, {
        max_height: 200,
        max_width: 200,
        callBack: (src, resultFile) => {
          that.editDataUser.avatar.val = resultFile;
          that.editDataUser.avatar.blob = src;
        }
      });
    },
    showThumbImg(file) {
      let img = new Image();
      img.onload = this.resizeImg.bind(null, img);
      img.src = URL.createObjectURL(file);
    },
    removeAvatar() {
      this.editDataUser.avatar.change_avatar = true;
      if (this.editDataUser.avatar.val) {
        this.editDataUser.avatar.val = null;
        this.editDataUser.avatar.blob = null;
      }
    },
    submitForm() {
      if (!this.submit) {
        this.submit = true;
        const data = {};
        Object.keys(this.editDataUser).map(item => {
          data[item] = this.editDataUser[item].val;
        });

        data.changed_avatar = this.editDataUser.avatar.change_avatar;
        if (this.editDataUser.password.val)
          data.password = this.editDataUser.password.val;

        const updated = { ...this.user, ...data };

        this.updateUser({ toChange: data, updated });
      }
    }
  },
  watch: {
    user(val) {
      this.prepareUserToEdit(val);
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    isDisabled() {
      return !(
        this.editDataUser.password.val ||
        this.editDataUser.avatar.change_avatar ||
        (this.user && this.editDataUser.name.val !== this.user.name) ||
        (this.user && this.editDataUser.surname.val !== this.user.surname) ||
        (this.user && this.editDataUser.email.val !== this.user.email)
      );
    }
  }
};
</script>

<style lang="scss">
</style>
